import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useMemo, useState } from 'react';
import { FilterProps } from '../../common/filter.util';
import { Divider, Grid } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import { VentoryColor } from '../../../../util/color.util';
import { t } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList/MultiSelectionList';
import SearchBar from '../../../common/SearchBar/SearchBar';
import { TaskStatus, taskStatusToString } from '../../../../../types/task';
import { TaskStatusFilter } from '../TaskStatusFilter';

interface TaskStatusFilterDropdownContentProps {
  filter: TaskStatusFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function TaskStatusFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: TaskStatusFilterDropdownContentProps) {
  const [query, setQuery] = useState<string>('');

  const values = useMemo(() => {
    return new Set([...Object.values(TaskStatus)].filter(status => filter.search(status, query)));
  }, [query, filter]);

  const handleChange = (selected: Set<string>) => {
    filterProps.taskStatus = selected;
    if (!filterProps.taskStatus?.size) filterProps.taskStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.taskStatus = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>{t(TranslationKey.taskStatus).singular.label}</p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.taskStatus}
          values={values}
          onChange={handleChange}
          toText={id => taskStatusToString(id)}
        />
      </Grid>
    </Grid>
  );
}
